import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import request from '@/router/axios';
export var getListDataScope = function getListDataScope(current, size, params) {
  return request({
    url: '/api/blade-system/data-scope/list',
    method: 'get',
    params: _objectSpread(_objectSpread({}, params), {}, {
      current: current,
      size: size
    })
  });
};
export var removeDataScope = function removeDataScope(ids) {
  return request({
    url: '/api/blade-system/data-scope/remove',
    method: 'post',
    params: {
      ids: ids
    }
  });
};
export var addDataScope = function addDataScope(row) {
  return request({
    url: '/api/blade-system/data-scope/submit',
    method: 'post',
    data: row
  });
};
export var updateDataScope = function updateDataScope(row) {
  return request({
    url: '/api/blade-system/data-scope/submit',
    method: 'post',
    data: row
  });
};
export var getMenuDataScope = function getMenuDataScope(id) {
  return request({
    url: '/api/blade-system/data-scope/detail',
    method: 'get',
    params: {
      id: id
    }
  });
};
export var getListApiScope = function getListApiScope(current, size, params) {
  return request({
    url: '/api/blade-system/api-scope/list',
    method: 'get',
    params: _objectSpread(_objectSpread({}, params), {}, {
      current: current,
      size: size
    })
  });
};
export var removeApiScope = function removeApiScope(ids) {
  return request({
    url: '/api/blade-system/api-scope/remove',
    method: 'post',
    params: {
      ids: ids
    }
  });
};
export var addApiScope = function addApiScope(row) {
  return request({
    url: '/api/blade-system/api-scope/submit',
    method: 'post',
    data: row
  });
};
export var updateApiScope = function updateApiScope(row) {
  return request({
    url: '/api/blade-system/api-scope/submit',
    method: 'post',
    data: row
  });
};
export var getMenuApiScope = function getMenuApiScope(id) {
  return request({
    url: '/api/blade-system/api-scope/detail',
    method: 'get',
    params: {
      id: id
    }
  });
};